import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@/contexts/AuthContext.tsx';
import userAccessApi from '@/features/dashboard/_root/api/userApi.ts';
import { userApiQueryKeys } from '@/features/dashboard/_root/api/userApi.queryKeys.ts';
import { User } from 'firebase/auth';

const useMe = () => {
  const { user } = useAuth();
  return useQuery(getMeQueryOptions(user));
};

export const getMeQueryOptions = (user: User | null) => ({
  queryKey: userApiQueryKeys.me(),
  queryFn: userAccessApi.getMe,
  enabled: !!user && user.emailVerified,
  refetchOnWindowFocus: true,
  staleTime: 1000 * 60 * 5,
  gcTime: Infinity,
});

export default useMe;
